export default function ThreeImagesIcon() {
  return (
    <svg width="49" height="48" viewBox="0 0 49 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_2461_26127)">
        <g clipPath="url(#clip1_2461_26127)">
          <path
            d="M22.861 19.1441L3.66249 24.7491C2.07204 25.2134 1.15913 26.8792 1.62347 28.4696L6.1075 43.8284C6.57184 45.4189 8.23758 46.3318 9.82804 45.8675L29.0266 40.2624C30.617 39.7981 31.5299 38.1324 31.0656 36.5419L26.5816 21.1831C26.1172 19.5926 24.4515 18.6797 22.861 19.1441Z"
            fill="#101313"
          />
          <path
            d="M22.861 19.1441L3.66249 24.7491C2.07204 25.2134 1.15913 26.8792 1.62347 28.4696L6.1075 43.8284C6.57184 45.4189 8.23758 46.3318 9.82804 45.8675L29.0266 40.2624C30.617 39.7981 31.5299 38.1324 31.0656 36.5419L26.5816 21.1831C26.1172 19.5926 24.4515 18.6797 22.861 19.1441Z"
            stroke="white"
            strokeWidth="1.5"
            strokeLinejoin="round"
          />
          <path
            d="M22.861 19.1441L3.66249 24.7491C2.07204 25.2134 1.15913 26.8792 1.62347 28.4696L6.1075 43.8284C6.57184 45.4189 8.23758 46.3318 9.82804 45.8675L29.0266 40.2624C30.617 39.7981 31.5299 38.1324 31.0656 36.5419L26.5816 21.1831C26.1172 19.5926 24.4515 18.6797 22.861 19.1441Z"
            stroke="black"
            strokeOpacity="0.2"
            strokeWidth="1.5"
            strokeLinejoin="round"
          />
          <path
            d="M20.3031 28.2284C21.3634 27.9189 21.972 26.8084 21.6624 25.7481C21.3529 24.6878 20.2424 24.0792 19.1821 24.3887C18.1218 24.6983 17.5132 25.8088 17.8227 26.8691C18.1323 27.9294 19.2428 28.538 20.3031 28.2284Z"
            stroke="white"
            strokeWidth="2"
            strokeMiterlimit="10"
          />
          <path
            d="M20.3031 28.2284C21.3634 27.9189 21.972 26.8084 21.6624 25.7481C21.3529 24.6878 20.2424 24.0792 19.1821 24.3887C18.1218 24.6983 17.5132 25.8088 17.8227 26.8691C18.1323 27.9294 19.2428 28.538 20.3031 28.2284Z"
            stroke="black"
            strokeOpacity="0.2"
            strokeWidth="2"
            strokeMiterlimit="10"
          />
          <path
            d="M20.6216 36.4524L13.5974 32.6114C13.1503 32.3664 12.6265 32.3015 12.133 32.4298C11.6396 32.5581 11.2138 32.8701 10.9427 33.3018L5.54672 41.909M17.5072 43.6258L22.7466 34.0656C22.986 33.6277 23.3805 33.2952 23.8526 33.1332C24.3247 32.9713 24.8402 32.9918 25.298 33.1905L30.7851 35.5824"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M20.6216 36.4524L13.5974 32.6114C13.1503 32.3664 12.6265 32.3015 12.133 32.4298C11.6396 32.5581 11.2138 32.8701 10.9427 33.3018L5.54672 41.909M17.5072 43.6258L22.7466 34.0656C22.986 33.6277 23.3805 33.2952 23.8526 33.1332C24.3247 32.9713 24.8402 32.9918 25.298 33.1905L30.7851 35.5824"
            stroke="black"
            strokeOpacity="0.2"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <g clipPath="url(#clip2_2461_26127)">
          <path
            d="M33.5977 6.4122L13.7692 9.02591C12.1265 9.24244 10.9705 10.7496 11.187 12.3922L13.278 28.255C13.4945 29.8977 15.0016 31.0538 16.6443 30.8372L36.4728 28.2235C38.1154 28.007 39.2715 26.4998 39.055 24.8572L36.964 8.99441C36.7475 7.35177 35.2403 6.19567 33.5977 6.4122Z"
            fill="#101313"
          />
          <path
            d="M33.5977 6.4122L13.7692 9.02591C12.1265 9.24244 10.9705 10.7496 11.187 12.3922L13.278 28.255C13.4945 29.8977 15.0016 31.0538 16.6443 30.8372L36.4728 28.2235C38.1154 28.007 39.2715 26.4998 39.055 24.8572L36.964 8.99441C36.7475 7.35177 35.2403 6.19567 33.5977 6.4122Z"
            stroke="white"
            strokeWidth="1.5"
            strokeLinejoin="round"
          />
          <path
            d="M33.5977 6.4122L13.7692 9.02591C12.1265 9.24244 10.9705 10.7496 11.187 12.3922L13.278 28.255C13.4945 29.8977 15.0016 31.0538 16.6443 30.8372L36.4728 28.2235C38.1154 28.007 39.2715 26.4998 39.055 24.8572L36.964 8.99441C36.7475 7.35177 35.2403 6.19567 33.5977 6.4122Z"
            stroke="black"
            strokeOpacity="0.2"
            strokeWidth="1.5"
            strokeLinejoin="round"
          />
          <path
            d="M29.6858 14.9973C30.7809 14.8529 31.5516 13.8482 31.4072 12.7531C31.2629 11.658 30.2581 10.8872 29.163 11.0316C28.0679 11.1759 27.2972 12.1807 27.4415 13.2758C27.5859 14.3709 28.5907 15.1416 29.6858 14.9973Z"
            stroke="white"
            strokeWidth="1.5"
            strokeMiterlimit="10"
          />
          <path
            d="M29.6858 14.9973C30.7809 14.8529 31.5516 13.8482 31.4072 12.7531C31.2629 11.658 30.2581 10.8872 29.163 11.0316C28.0679 11.1759 27.2972 12.1807 27.4415 13.2758C27.5859 14.3709 28.5907 15.1416 29.6858 14.9973Z"
            stroke="black"
            strokeOpacity="0.2"
            strokeWidth="1.5"
            strokeMiterlimit="10"
          />
          <path
            d="M28.7468 23.1749L22.39 18.3083C21.9854 17.998 21.4776 17.8539 20.9704 17.9056C20.4632 17.9572 19.9948 18.2006 19.661 18.586L13.0164 26.2703M24.5755 29.7899L31.2107 21.1398C31.5141 20.7435 31.9546 20.475 32.4458 20.3869C32.9371 20.2988 33.4435 20.3976 33.8656 20.6638L38.9241 23.8639"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M28.7468 23.1749L22.39 18.3083C21.9854 17.998 21.4776 17.8539 20.9704 17.9056C20.4632 17.9572 19.9948 18.2006 19.661 18.586L13.0164 26.2703M24.5755 29.7899L31.2107 21.1398C31.5141 20.7435 31.9546 20.475 32.4458 20.3869C32.9371 20.2988 33.4435 20.3976 33.8656 20.6638L38.9241 23.8639"
            stroke="black"
            strokeOpacity="0.2"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <g clipPath="url(#clip3_2461_26127)">
          <path
            d="M44.828 21.8906L25.0311 19.0475C23.391 18.812 21.8706 19.9506 21.6351 21.5906L19.3607 37.4281C19.1251 39.0682 20.2637 40.5886 21.9038 40.8241L41.7007 43.6671C43.3407 43.9027 44.8611 42.7641 45.0966 41.1241L47.371 25.2865C47.6066 23.6465 46.468 22.1261 44.828 21.8906Z"
            fill="#101313"
          />
          <path
            d="M44.828 21.8906L25.0311 19.0475C23.391 18.812 21.8706 19.9506 21.6351 21.5906L19.3607 37.4281C19.1251 39.0682 20.2637 40.5886 21.9038 40.8241L41.7007 43.6671C43.3407 43.9027 44.8611 42.7641 45.0966 41.1241L47.371 25.2865C47.6066 23.6465 46.468 22.1261 44.828 21.8906Z"
            stroke="white"
            strokeWidth="1.5"
            strokeLinejoin="round"
          />
          <path
            d="M44.828 21.8906L25.0311 19.0475C23.391 18.812 21.8706 19.9506 21.6351 21.5906L19.3607 37.4281C19.1251 39.0682 20.2637 40.5886 21.9038 40.8241L41.7007 43.6671C43.3407 43.9027 44.8611 42.7641 45.0966 41.1241L47.371 25.2865C47.6066 23.6465 46.468 22.1261 44.828 21.8906Z"
            stroke="black"
            strokeOpacity="0.2"
            strokeWidth="1.5"
            strokeLinejoin="round"
          />
          <path
            d="M38.7417 29.0991C39.835 29.2562 40.8486 28.4971 41.0056 27.4038C41.1627 26.3104 40.4036 25.2968 39.3103 25.1398C38.2169 24.9828 37.2033 25.7418 37.0463 26.8352C36.8893 27.9285 37.6483 28.9421 38.7417 29.0991Z"
            stroke="white"
            strokeWidth="1.5"
            strokeMiterlimit="10"
          />
          <path
            d="M38.7417 29.0991C39.835 29.2562 40.8486 28.4971 41.0056 27.4038C41.1627 26.3104 40.4036 25.2968 39.3103 25.1398C38.2169 24.9828 37.2033 25.7418 37.0463 26.8352C36.8893 27.9285 37.6483 28.9421 38.7417 29.0991Z"
            stroke="black"
            strokeOpacity="0.2"
            strokeWidth="1.5"
            strokeMiterlimit="10"
          />
          <path
            d="M35.6266 36.7218L30.8218 30.3182C30.5162 29.9101 30.0662 29.6342 29.5639 29.5468C29.0616 29.4594 28.5449 29.5671 28.1194 29.848L19.6451 35.4502M29.8226 41.9631L38.5489 35.4285C38.948 35.1289 39.4448 34.9894 39.9415 35.0374C40.4383 35.0854 40.8992 35.3173 41.2337 35.6877L45.2389 40.136"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M35.6266 36.7218L30.8218 30.3182C30.5162 29.9101 30.0662 29.6342 29.5639 29.5468C29.0616 29.4594 28.5449 29.5671 28.1194 29.848L19.6451 35.4502M29.8226 41.9631L38.5489 35.4285C38.948 35.1289 39.4448 34.9894 39.9415 35.0374C40.4383 35.0854 40.8992 35.3173 41.2337 35.6877L45.2389 40.136"
            stroke="black"
            strokeOpacity="0.2"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_2461_26127">
          <rect width="48" height="48" fill="white" transform="translate(0.5)" />
        </clipPath>
        <clipPath id="clip1_2461_26127">
          <rect width="32" height="32" fill="white" transform="translate(-3.49854 21.6328) rotate(-16.2752)" />
        </clipPath>
        <clipPath id="clip2_2461_26127">
          <rect width="32" height="32" fill="white" transform="translate(7.16699 4.85156) rotate(-7.50922)" />
        </clipPath>
        <clipPath id="clip3_2461_26127">
          <rect width="32" height="32" fill="white" transform="translate(19.8027 13.2461) rotate(8.1723)" />
        </clipPath>
      </defs>
    </svg>
  );
}
